import {ApiRequest, ApiRequestObservable} from "framework/api";
import {ApplicationState} from 'framework/applicationState';
import {createModelSchemaWrapper} from "framework/serializr-integration";
import {list, primitive} from "serializr";
import {SaveTagsModel} from "./tagsModel";
import { UrlBuilder } from "tools";

export class TagsData {
	forceTeamTags: boolean;
	forceUserTags: boolean;
	ignoreTags: boolean;
	showUntagged: boolean;
	tags: string[];
}

export interface TagInfo {
	value: string;
	text: string;
	accountId: string;
	accountName: string;
}

createModelSchemaWrapper(TagsData, {
	forceTeamTags: primitive(),
	forceUserTags: primitive(),
	ignoreTags: primitive(),
	showUntagged: primitive(),
	tags: list(primitive()),
});

export function getUserTags(){
	return new ApiRequest<TagsData>({
		url: `users/${ApplicationState.userId}/tags`,
		accountBased: true,
		method: 'GET',
		responseType: TagsData
	});
}

export function getTagList({accountId, includeSubaccounts}: {accountId: string, includeSubaccounts: boolean} = {accountId: null, includeSubaccounts: false}) {
	return new ApiRequestObservable<string[]>({
		url: `tags`,
		accountBased: true,
		accountId,
		includeSubaccounts,
		method: 'GET',
		subaccountsFilter: true
	});
}

export function getTagListByAccount(
	{ includeSubaccounts }: { includeSubaccounts: boolean } = { includeSubaccounts: false },
) {
	return new ApiRequestObservable<TagInfo[]>({
		url: `tagsByAccount`,
		accountBased: true,
		includeSubaccounts,
		method: 'GET',
		subaccountsFilter: true,
	});
}

export function saveTags(model: SaveTagsModel) {
	return new ApiRequest<string[]>({
		url: `users/${ApplicationState.userId}/tags`,
		accountBased: true,
		method: 'POST',
		payload: model
	});
}
